/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Subaccount update request
 */
export interface SubAccountUpdateRequest {
  accountId: number;
  name: string;
  status: SubAccountUpdateRequest.StatusEnum;
  allowNegativeEquityWithdraw: boolean;
  /**
   * Can be modified only by superadmin.
   */
  disableWithdrawBalanceCheck: boolean;
}
export namespace SubAccountUpdateRequest {
  export const StatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Paused: 'PAUSED',
    Locked: 'LOCKED',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
}
